import Resource from './Resource';

export default class Profile extends Resource{
	constructor(options={}) {
		let {
			routeParams = {},
			query = {},
			data = {}
		} = options;

		let route = !!routeParams.setting ? `profile/:setting` : 'profile';

		let config = {
			route: route,
			routeParams: routeParams,
			query: query,
			data: data
		};

		super(config);
		return this;
	}

	get() {
		return this.request();
	}

	post() {
		return this.request('post');
	}

	put() {
		return this.request('put');
	}
}
